import { Link } from 'react-router-dom'
import styles from './SitemapLayout.module.scss'

function SitemapLayout({ sitemapData }) {
  return (
    <div className={styles.container}>
      {sitemapData.map((item) => (
        <div className={styles.menuGroupContainer}>
          <h3>{item?.link?.label}</h3>
          {item?.menus?.length > 0 && (
            <div className={styles.menusContainer}>
              {item?.menus.map((menu) => (
                <Link to={menu?.link?.path} className={styles.menu}>
                  {menu?.link?.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default SitemapLayout
